__turbopack_context__.v({
  "loading": "ProductResults-module-scss-module__H-lxRq__loading",
  "product-results": "ProductResults-module-scss-module__H-lxRq__product-results",
  "product-results__message": "ProductResults-module-scss-module__H-lxRq__product-results__message",
  "product-results__message--success": "ProductResults-module-scss-module__H-lxRq__product-results__message--success",
  "product-results__message--warn": "ProductResults-module-scss-module__H-lxRq__product-results__message--warn",
  "product-results__message-icon": "ProductResults-module-scss-module__H-lxRq__product-results__message-icon",
});
